import StorageService from '@/services/storage.service';

/**
 * auth service handle global authrization.
 */
export default {
  request(config) {
    const params = config;
    // if (params.url !== '/login') {
    //   params.headers.Authorization = `Bearer ${StorageService.getToken()}`;
    // }
    return params;
  },
};
